module.exports = __webpack_public_path__ + "static/media/close.5b5c65b3.svg";